// ** Redux Imports
import { combineReducers } from 'redux';

// ** Reducers Imports
import orders from './orders';
import orderEvents from './order-events';
import transferRequests from './transfer-requests';
import invoices from './invoices';
import returnInvoices from './return-invoices';
import transactions from './transactions';

const driverReducer = combineReducers({
  orders,
  orderEvents,
  transferRequests,
  invoices,
  returnInvoices,
  transactions,
});

export default driverReducer;
